export const API_ERROR_MESSAGE = {
  genericError:
    'Sorry, an unknown error occurred, please contact us to see if we can help.',
  twoFaInvalidToken: 'The code you entered is invalid. Please try again.',
  forbiddenPassword:
    'We recognise this as a commonly used password. Try something more unique.',
  tooManyChangePasswordRequests:
    'We have received too many change password requests for your account.',
  invalidOTPKey: 'You entered an incorrect verification code.',
  domainInUse: 'The requested domain is already in use',
  childOrganisationCannotBeAParent:
    'The Parent Organisation you’ve selected is already a Child - it cannot be a Parent.',
  linkExpired: 'The link has expired.',
  imageFileSize: 'Maximum image size allowed is 2 MB.',
  rateExceeded:
    'Too many requests hit the API too quickly. Please try again later.',
  linkInvalid: 'The link is invalid.',
  tokenInvalid:
    'We couldn’t process your response because the link is not valid anymore. Use the link below if you think there’s been a mistake',
}

type MinimalApiError = {
  code?: string
  reasons?: string[]
  message?: string
}

export const APIErrorHandler = (error?: MinimalApiError | null) => {
  if (error) {
    switch (error.code) {
      case 'auth/two_fa_authentication_failed':
        return API_ERROR_MESSAGE.twoFaInvalidToken
      case 'activity_event/eligibility_already_defined':
      case 'auth/two_fa_invalid_recovery_code':
      case 'forbidden':
      case 'accounts/invalid':
      case 'bad_request':
      case 'auth/invalid_credentials_1':
      case 'auth/invalid_credentials_2':
      case 'auth/invalid_credentials_3':
      case 'auth/invalid_credentials_4':
      case 'auth/password_unsafe_1':
      case 'auth/password_unsafe_2':
      case 'validation_request/invalid_registry_id_format':
      case 'conflict':
      case 'upload/filetype_not_supported':
      case 'auth/two_fa_not_enabled':
      case 'auth/must_login_with_sso':
        return (
          (error.reasons?.[0] || error.message) ??
          API_ERROR_MESSAGE.genericError
        )
      case 'unprocessable_entity':
        return error.reasons?.[0] ?? API_ERROR_MESSAGE.genericError
      case 'auth/two_fa_invalid_otp_code':
        return API_ERROR_MESSAGE.invalidOTPKey
      case 'auth/forbidden_password':
        return API_ERROR_MESSAGE.forbiddenPassword
      case 'auth/too_many_change_password_requests':
        return API_ERROR_MESSAGE.tooManyChangePasswordRequests
      case 'sso/domain_in_use':
        return API_ERROR_MESSAGE.domainInUse
      case 'validation_request/child_organisation_cannot_be_a_parent':
        return API_ERROR_MESSAGE.childOrganisationCannotBeAParent
      case 'upload/max_file_size':
        return API_ERROR_MESSAGE.imageFileSize
      case 'auth/link_expired':
        return API_ERROR_MESSAGE.linkExpired
      case 'rate_exceeded':
        return API_ERROR_MESSAGE.rateExceeded
      case 'auth/link_invalid':
        return API_ERROR_MESSAGE.linkInvalid
      case 'agent_verification_organisation_association/invalid_token':
        return API_ERROR_MESSAGE.tokenInvalid
      case 'not_found':
      default:
        return API_ERROR_MESSAGE.genericError
    }
  }

  return API_ERROR_MESSAGE.genericError
}
